import Vue from 'vue'
import Toast from './Toast/Toast'

const opt = {
  duration: 3000
}

export default function(msg, options) {
  let callback = null

  if (typeof options === 'object') {
    Object.keys(options).forEach((key) => {
      opt[key] = options[key]
    })
  } else if (typeof options === 'function') {
    callback = options
  }

  const ToastComponent = Vue.extend(Toast)
  const instance = new ToastComponent().$mount(document.createElement('div'))

  instance.msg = msg
  instance.visible = true

  document.body.appendChild(instance.$el)

  setTimeout(() => {
    instance.visible = false
    setTimeout(() => {
      document.body.removeChild(instance.$el)
      callback && callback()
    }, 500)
  }, opt.duration)
}
